var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useId } from 'react';
import { CustomComponent } from '../../utils/CustomComponent';
import { omitStyleProps } from '../../utils/props';
import { COLOR_SET_CLASSES, applySpacings, customTV } from '../../utils/tailwind';
import { Icon } from '../Icon/Icon';
import { Typography } from '../Typography/Typography';
import { chip, chipAction, chipIcon } from './styles';
export const Chip = (_a) => {
    var { avatar, label, labelVariant = 'footnote', colorSet = 'default', invertedColor = false, disabled, endIcon, startIcon, noWrap, className, onClick, onDelete } = _a, props = __rest(_a, ["avatar", "label", "labelVariant", "colorSet", "invertedColor", "disabled", "endIcon", "startIcon", "noWrap", "className", "onClick", "onDelete"]);
    const labelId = useId();
    const invertColorsKey = invertedColor && !disabled ? 'inverted' : 'default';
    const colors = COLOR_SET_CLASSES[colorSet][invertColorsKey];
    const disableColors = COLOR_SET_CLASSES['interactive.secondary.disabled'].default;
    const chipLabel = customTV({
        base: colors.content,
        variants: {
            disabled: { true: disableColors.content },
        },
    });
    const asButton = !!onClick;
    return (_jsxs(CustomComponent, Object.assign({ "aria-labelledby": labelId, as: asButton ? 'button' : 'div', disabled: disabled, onClick: asButton && !disabled ? onClick : undefined }, omitStyleProps(props), { className: chip({
            asButton,
            avatar: avatar !== undefined,
            noWrap,
            disabled,
            className: [colors.background, applySpacings(props), className],
        }), children: [avatar !== undefined && React.cloneElement(avatar, { size: 24, mr: 4 }), startIcon && !avatar && (_jsx("div", { className: "self-start", children: _jsx(Icon, { name: startIcon, size: 20, className: chipIcon({
                        disabled,
                        className: [!disabled && colors.icon, 'mr-4'],
                    }) }) })), _jsx(Typography, { id: labelId, variant: labelVariant, weight: "medium", className: chipLabel({
                    disabled,
                    className: [!endIcon && 'mr-6', !startIcon && 'ml-6'],
                }), children: label }), onDelete ? (_jsx("button", { type: "button", onClick: (event) => {
                    onDelete();
                    event.stopPropagation();
                }, className: chipAction({
                    className: disabled && disableColors.content,
                }), children: _jsx(Icon, { name: "cancel-circle", className: chipIcon({
                        disabled,
                        className: disabled ? disableColors.icon : colors.icon,
                    }), size: 16 }) })) : endIcon ? (_jsx("div", { className: "self-start", children: _jsx(Icon, { name: endIcon, className: chipIcon({
                        disabled,
                        className: [!disabled && colors.icon, 'ml-4'],
                    }), size: 20 }) })) : null] })));
};
